import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import RegistrationForm from "./pages/Registration/RegistrationForm";

import FAQ from "./components/FAQ";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import Login from "./pages/Login/Login";
import Prices from "./pages/Prices";
import { Products } from "./components/Products";
import { Projects } from "./components/Projects";
import { News } from "./components/News";
import { Maintenance } from "./components/Maintenance";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
       <Route path="/prices" element={<Prices />} />
      <Route path="/contact" element={<Contact />} />
     <Route path="/projects" element={<Projects />} />
     <Route path="/news" element={<News />} />
     <Route path="/maintenance" element={<Maintenance />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/products" element={<Products />} />
   
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/registrationForm" element={<RegistrationForm />} />
    </Routes>
  );
}

export default App;
